// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar-7EnEFnj2"};